export default ":host {\n  background-color: var(--rp-color-gray50);\n}\n\n:host r-application-terms-and-conditions {\n  width: 800px;\n}";